// extracted by mini-css-extract-plugin
module.exports =  {"srOnly":"SKDkWT"};